/**
 * 演示重置工具
 * - URL 参数 ?reset=true 时自动清空所有 localStorage 数据
 * - 导出 resetDemo() 函数供手动调用
 */

const STORAGE_KEYS = [
  'role',
  'loginInfo',
  'evidence',
  'tasks',
  'bind',
  'loading',
  'receipt',
  'anomaly',
  'qc',
  'draft:qc:BLU-C0047',
];

export function resetDemo(): void {
  for (const key of STORAGE_KEYS) {
    localStorage.removeItem(key);
  }
}

/** 在 App 挂载时检查 URL 参数，自动执行重置 */
export function checkAndReset(): boolean {
  const params = new URLSearchParams(window.location.search);
  if (params.get('reset') === 'true') {
    resetDemo();
    // 清除 URL 中的 reset 参数，避免刷新重复重置
    const url = new URL(window.location.href);
    url.searchParams.delete('reset');
    window.history.replaceState({}, '', url.toString());
    return true;
  }
  return false;
}
